import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3.5","key":"svg-2"}],["path",{"d":"M16 22l5 -5","key":"svg-3"}],["path",{"d":"M21 17v4.5","key":"svg-4"}],["path",{"d":"M21 17h-4.5","key":"svg-5"}]]

const IconFilter2Share = createReactComponent('outline', 'filter-2-share', 'Filter2Share', __iconNode);

export default IconFilter2Share;